var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.131,
    height: 12.125,
    viewBox: "0 0 14.131 12.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5496",
    "data-name": "Group 5496",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M570.445-92.472V-90.3a1.4,1.4,0,0,0,1.4,1.4h10.135a1.4,1.4,0,0,0,1.4-1.4v-4.347h-3.942a2.589,2.589,0,0,1-2.524,2.016,2.589,2.589,0,0,1-2.524-2.016h-3.942",
    transform: "translate(-570.445 99.826)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M576.911-102.271a2.589,2.589,0,0,0,2.524-2.016h3.942l-2.058-5.179H572.5l-2.058,5.179h3.942A2.589,2.589,0,0,0,576.911-102.271Z",
    transform: "translate(-570.445 109.467)",
    fill: "none",
    stroke: "#939299",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.81265b9fcfa5e6e852cfd1d4c7fd3283.svg";
export { ForwardRef as ReactComponent };